module.exports = __webpack_public_path__ + "static/media/STPCompleted.empty.fed5c598.png";